import type { SwiperOptions } from 'swiper/types';

export function calculateVisibleSlides(config: SwiperOptions, viewportWidth: number, totalSlides = Infinity): number {
    let visible = 1;
    const { slidesPerView, breakpoints } = config;

    if (typeof slidesPerView === 'number') {
        visible = slidesPerView;
    } else if (breakpoints) {
        const matched = Object.keys(breakpoints)
            .map(Number)
            .filter(bp => bp <= viewportWidth)
            .sort((a, b) => b - a)[0];

        const matchConfig = breakpoints[matched];
        if (!isNaN(matchConfig?.slidesPerView)) {
            visible = matchConfig.slidesPerView;
        }
    }

    return Math.min(visible, totalSlides);
}


export function calculateTotalPages(totalSlides: number, visibleSlides: number): number {
    return Math.max(1, totalSlides - visibleSlides + 1);
}

export function calculateCurrentPage(progress: number, totalPages: number): number {
    const clamped = Math.min(Math.max(progress, 0), 1);
    return Math.round(clamped * (totalPages - 1)) + 1;
}
